import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://api.sheshisam.com',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Opcional: Añade interceptores para manejo global de errores
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        console.error('Error de Axios:', error);
        return Promise.reject(error);
    }
);

export default axiosInstance;